import { filter } from 'lodash';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Table,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Box,
  Button
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import CreateIcon from '@material-ui/icons/Create';
import { da } from 'date-fns/locale';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClaimsContext } from '../../context/claims_context';
import { ClientListHead, ClaimsListToolbar } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'edits', label: 'Edit', alignRight: true },
  { id: 'dels', label: 'Del', alignRight: true },
  { id: 'batchnu', label: 'Claim #', alignRight: true },
  { id: 'serty2', label: 'Service Type', alignRight: false },
  { id: 'serty2', label: 'Service For', alignRight: false },
  { id: 'doccode3', label: 'Policy Holder', alignRight: false },
  { id: 'startc4', label: 'EC #', alignRight: false },
  { id: 'batchnu5', label: 'Created Date', alignRight: true },
  { id: 'docode6', label: 'Awarded', alignRight: true },
  { id: 'doccode7', label: 'Province', alignRight: true },
  { id: 'stat', label: 'Claim Status', alignRight: false },
  { id: 'dp', label: 'Date Paid', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, filt) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_doc) => _doc[filt].toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function SelectBatch() {
  const {
    setBatchNo,
    clearBatch,
    setCurrentBatch,
    setClaimNo,
    clearClaims,
    getClaimById,
    getClaimDetailsById,
    populateClaimDocuments
  } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [claimsFilter, setClaimsFilter] = useState('');
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [ogList, setOgList] = useState([]);
  const [orderBy, setOrderBy] = useState('claim_IDs');
  const [filterName, setFilterName] = useState('');
  const [filterField, setFilterField] = useState('memberShipNo');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    getBatchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderBy]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const getBatchDetails = async () => {
    setLoading(true);
    console.log('received batchNo');
    await axios(`${baseUrl}/api/Claims/getClaimsDetailed`).then(
      (res) => {
        setLoading(false);
        console.log('returned getBatchClaims', res);
        console.log(
          'returned filtered',
          res.data.result.filter(
            (item) => item.userId === Number(sessionStorage.getItem('userRefId'))
          )
        );
        if (sessionStorage.getItem('dept') === '5') {
          console.log('pfee apa 1');
          setDataList(
            res.data.result.filter(
              (item) => item.userId === Number(sessionStorage.getItem('userRefId'))
            )
          );
        } else {
          console.log('pfee apa 3', res.data.result);
          console.log(
            'pfee apa 2',
            res.data.result.filter((item) => item.workStation === 'zimta-assurance.web.app')
          );
          setOgList(res.data.result);
          setDataList(
            res.data.result.filter((item) => item.workStation === 'zimta-assurance.web.app')
          );
        }
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  function filterClaimsByType(filterType) {
    console.log('filtering by type:', filterType);
    setClaimsFilter(filterType);
    if (filterType === 'new') {
      setDataList(ogList.filter((item) => item.workStation === 'zimta-assurance.web.app'));
    }
    if (filterType === 'historical') {
      setDataList(ogList.filter((item) => item.workStation !== 'zimta-assurance.web.app'));
    }
  }

  const handleBatchDelete = async (e) => {
    console.log('e here', e.batchID);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/claims/deleteBatch?batchId=${e.batchID}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Batch!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Batch Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Batch!: ${error}`, 'error');
      }
    );
  };

  const handleBatchView = (e) => {
    setBatchNo(e.row.batchID);
    setCurrentBatch(e.row);
    openView(e.row.batch_No);
  };

  const handleClaimDelete = async (e) => {
    console.log('e here', e.claim_ID);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/claims/deleteClaim?claimId=${e.claim_ID}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Claim!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Claim Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Claim!: ${error}`, 'error');
      }
    );
  };

  const handleClaimView = (e) => {
    console.log('e claimId', e.row.claim_ID);
    console.log('e claim#', e.row.claim_No);
    setClaimNo(e.row.claim_ID);
    getClaimById(e.row.claim_ID);
    getClaimDetailsById(e.row.claim_ID);
    populateClaimDocuments(e.row.claim_ID);
    openView(e.row.claim_ID);
  };

  const openView = (e) => {
    navigate(`/claims/processClaim/${e}`);
  };

  const openNew = () => {
    clearClaims();
    setClaimNo(0);
    navigate(`/claims/claim/0`);
  };

  const openNewSelf = () => {
    clearBatch();
    navigate(`/claims/batchmultipledr`);
  };

  const openEdit = () => {
    navigate(`/claims/createbatches`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };
  //  Filter by claim type (dropdown)
  // const claimsByType = filterClaimsByType(dataList, claimsFilter);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;
  // const filterField = 'serviceType';
  const filteredUsers = applySortFilter(
    dataList,
    getComparator(order, orderBy),
    filterName,
    filterField
  );

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          Select Claim to Process
        </Typography>
        {/* claim filter drop down */}
        <FormControl
          variant="outlined"
          size="small"
          style={{ minWidth: 200, marginBottom: 16, alignContent: 'center' }}
        >
          <InputLabel id="claims-filter-label">Claims Filter</InputLabel>
          <Select
            labelId="claims-filter-label"
            id="claims-filter"
            value={claimsFilter}
            onChange={(e) => filterClaimsByType(e.target.value)}
            label="Claims Filter"
          >
            <MenuItem value="" disabled style={{ color: '#888' }}>
              Claim Filter
            </MenuItem>
            <MenuItem value="new">New Claims</MenuItem>
            <MenuItem value="historical">Historical Claims</MenuItem>
          </Select>
        </FormControl>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          onClick={() => getBatchDetails()}
        >
          Refresh
        </Button>

        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => openNew()}
        >
          Create New Claim
        </Button>
      </Stack>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <ClaimsListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          setFilterName={setFilterName}
          setFilterField={setFilterField}
        />
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const {
                    claim_ID,
                    patientName,
                    claimStatusId,
                    scheme,
                    serviceType,
                    grossTotal,
                    awardTotal,
                    invoice_No,
                    claimStatus,
                    memberShipNo,
                    deceasedName,
                    dateCreated,
                    province,
                    datePaid
                  } = row;
                  const isItemSelected = selected.indexOf(claim_ID) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={claim_ID}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />
                      <TableCell align="right">
                        <IconButton onClick={() => handleClaimView({ row })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                      </TableCell>
                      <TableCell align="right">
                        {claimStatusId === 1 && Number(sessionStorage.getItem('userRefId')) < 10 && (
                          <IconButton
                            onClick={() =>
                              setConfirmDialog({
                                isOpen: true,
                                title: 'Are you sure you want to Delete Claim',
                                subTitle: "You can't undo this action",
                                heading: 'Delete Claim',
                                color: '#00000',
                                onConfirm: () => {
                                  handleClaimDelete({ claim_ID });
                                }
                              })
                            }
                          >
                            <DeleteForeverIcon sx={{ color: '#f44336' }} />
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell align="right">{claim_ID}</TableCell>
                      <TableCell align="left">{serviceType}</TableCell>
                      <TableCell align="left">{invoice_No}</TableCell>
                      <TableCell align="left">{patientName}</TableCell>
                      <TableCell align="left">{memberShipNo}</TableCell>
                      <TableCell align="right" component="th" scope="row" padding="none">
                        {moment(dateCreated).isValid()
                          ? moment(dateCreated).format('YYYY-MM-DD')
                          : ''}
                      </TableCell>
                      <TableCell align="right">{awardTotal.toFixed(2)}</TableCell>
                      <TableCell align="right">{province}</TableCell>
                      <TableCell align="left">{claimStatus}</TableCell>
                      <TableCell align="right" component="th" scope="row" padding="none">
                        {moment(datePaid).isValid()}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </>
  );
}
